export const SITE_NAME = 'MC에듀';
export const SITE_ALTERNATE_NAME = 'MC교육컨텐츠';
export const SITE_URL =
  (import.meta.env.VITE_SITE_URL as string | undefined) || 'https://mcedu.app';
export const SITE_DESCRIPTION =
  'MC에듀는 진로·계열 탐색, 선택과목 추천, 공부법 검사, IQ 검사, 어휘력·문해력 검사를 제공하는 교육 진단 플랫폼입니다. 2022 개정 교육과정을 반영해 학생 개개인의 진로와 학습 방향을 정확하게 진단합니다.';

export interface RouteSeo {
  path: string;
  title: string;
  description: string;
  keywords: string;
  noindex?: boolean;
}

const ROUTE_SEO: RouteSeo[] = [
  {
    path: '/',
    title: 'MC에듀 - 진로·계열·전공·직업 탐색 검사',
    description: SITE_DESCRIPTION,
    keywords: '진로탐색, 선택과목 추천, 공부법 검사, IQ 검사, 어휘력 검사',
  },
  {
    path: '/inquiry',
    title: '문의 및 건의사항 - MC에듀',
    description:
      'MC에듀 서비스 이용 중 궁금한 점이나 건의사항을 남겨주세요. 진로·계열 탐색, 선택과목 추천, 공부법 검사, IQ 검사, 어휘력·문해력 검사 관련 문의를 빠르게 안내드립니다.',
    keywords: '문의, 건의사항, 고객센터, MC에듀',
  },
  {
    path: '/terms',
    title: '이용약관 - MC에듀',
    description:
      'MC에듀 교육 진단 및 진로·학습 분석 서비스 이용약관입니다. 회원의 권리와 의무, 이용권 및 환불 정책을 확인하세요.',
    keywords: '이용약관, MC에듀',
  },
  {
    path: '/privacy',
    title: '개인정보처리방침 - MC에듀',
    description:
      'MC에듀 개인정보처리방침입니다. 수집하는 개인정보 항목, 수집·이용 목적, 보유 기간, 회원의 권리를 확인하세요.',
    keywords: '개인정보처리방침, MC에듀',
  },
];

// 인덱싱 불가(비공개/인증 필요) 페이지용 제목. SEO 최적화는 수행하지 않음.
const PRIVATE_TITLES: Record<string, string> = {
  '/login': '로그인 - MC에듀',
  '/find-account': '아이디 찾기 - MC에듀',
  '/reset-password': '비밀번호 재설정 - MC에듀',
  '/dashboard': '대시보드 - MC에듀',
  '/my-profile': '내 정보 - MC에듀',
  '/my-results': '내 검사 결과 - MC에듀',
  '/admin': '관리자 - MC에듀',
  '/career-test': '진로·계열 탐색 검사 - MC에듀',
  '/subject-guide': '선택과목 추천 - MC에듀',
  '/study-style': '공부법 검사 - MC에듀',
  '/iq-test': 'IQ 검사 - MC에듀',
  '/literacy-test': '어휘력·문해력 검사 - MC에듀',
  '/english-test': '영어 단어 검사 - MC에듀',
};

export function resolveSeo(pathname: string): RouteSeo {
  const exact = ROUTE_SEO.find((r) => r.path === pathname);
  if (exact) return exact;

  if (PRIVATE_TITLES[pathname]) {
    return {
      path: pathname,
      title: PRIVATE_TITLES[pathname],
      description: '',
      keywords: '',
      noindex: true,
    };
  }

  // 동적 경로(/academy/:id 등) 및 미정의 경로(404 포함)는 noindex 처리
  return {
    path: pathname,
    title: SITE_NAME,
    description: '',
    keywords: '',
    noindex: true,
  };
}